import { Section, SectionHeader, SectionTitle } from "@/blocks/Section";
import { useCall } from "@/hooks/useCall/useCall";
import { useGetCustomSummaryResults } from "@/hooks/useGetCustomSummaryResults";
import { Spinner } from "@aircall/ds";
import { BetaTag } from "../BetaTag/BetaTag";
import { CustomSummaryResultsForm } from "../CustomSummaryForm/CustomSummaryResultsForm";

export function SectionCustomSummary() {
  const { call } = useCall();
  const callId = call?.id ?? undefined;
  const { customSummaryResult, loading } = useGetCustomSummaryResults(callId);

  if (!callId) {
    return null;
  }

  if (loading) {
    return (
      <div className="flex h-[70px] w-full items-center justify-center">
        <Spinner data-test="loader" />
      </div>
    );
  }

  if (!customSummaryResult) {
    return null;
  }

  const title = customSummaryResult.customSummary.name;

  return (
    <Section data-test="custom-summary-section">
      <SectionHeader addon={<BetaTag />}>
        <SectionTitle>{title}</SectionTitle>
      </SectionHeader>

      <div className="flex flex-col rounded-md bg-muted p-4">
        <CustomSummaryResultsForm
          customSummaryResultId={customSummaryResult.id}
          templateResults={customSummaryResult.templateResults}
          templates={customSummaryResult.customSummary.templates}
        />
      </div>
    </Section>
  );
}
